export default __webpack_public_path__ + "static/media/mobileAbcSlide.dad4cfab.png";